// (C) Copyright 2025 Hewlett Packard Enterprise Development LP
import { Route, Routes } from 'react-router-dom'
import React from 'react'

import GetStartedVideosPage from './GetStartedVideos'

const GetStartedRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<GetStartedVideosPage />} />
    </Routes>
  )
}

export default GetStartedRouter
